module.exports = __webpack_public_path__ + "static/fonts/Roboto Slab Regular.ff3580f1.woff";